import { map } from "fxjs/es";

export default map;
